import { createSelector } from 'reselect';

import options from './options';

const { name } = options;

export const getYearCatalog = state => state.models[name].data;
export const getCurYear = state => state.models[name].item;